export default {
  name: "News"
};